export enum LoanTerms {
  THIRTY = 'THIRTY',
  TWENTY = 'TWENTY',
  FIFTEEN = 'FIFTEEN'
}
